<template>
  <BatteryEmissionsAnalyzerTab
    :initial-fields="initialFields"
    :reports="reports"
    :loading="loading"
  />
</template>

<script setup lang="ts">
import BatteryEmissionsAnalyzerTab from '~/components/sustainability/BatteryEmissionsAnalyzerTab.vue'
import { useReports } from '~/composables/useReports'
import type { TMarketServiceConfig } from '~/src/types/markets'
import type { TRecord } from '~/src/types/common'

const props = defineProps<{
  market: TMarketServiceConfig
  initialFields: TRecord[]
}>()

const { getBatteryEmissionsAnalyserReports } = useReports()

const { data, status } = await getBatteryEmissionsAnalyserReports(
  props.market.slug,
)

const loading = computed(() => status.value !== 'success')
const reports = computed(() => data.value || [])

definePageMeta({ isTab: true, layout: 'services' })
</script>
